import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Hero from './sections/Hero';
import PlayerStats from './sections/PlayerStats';
import ShowdownWall from './sections/ShowdownWall';
import HandReplay from './sections/HandReplay';
import SettleUp from './sections/SettleUp';
import Toolkit from './sections/Toolkit';
import Pricing from './sections/Pricing';
import FinalCta from './sections/FinalCta';

export default function Landing({ setCurrentPage }) {
  const { currentUser } = useAuth();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const go = page => {
    setCurrentPage(page);
    window.scrollTo({ top: 0 });
  };
  const start = () => go(currentUser ? 'fullLogUpload' : 'register');
  const trial = () => go(currentUser ? 'payment' : 'register');
  const scrollTo = id => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });

  return (
    <div className="pn-page pn-grain">
      <Hero onStart={start} onExample={() => scrollTo('players')} />
      <PlayerStats />
      <ShowdownWall />
      <HandReplay />
      <SettleUp />
      <Toolkit />
      <Pricing onStart={start} onTrial={trial} />
      <FinalCta onStart={start} />
    </div>
  );
}
